import WorkflowBoard from "@/components/workflow/WorkflowBoard";
import OpsWorkflowNav from "@/components/workflow/OpsWorkflowNav";
import { api } from "@/lib/api";

export default function ProductionWorkflow() {
  return (
    <div className="flex flex-col h-full">
      <OpsWorkflowNav />
      <div className="flex-1 min-h-0">
        <WorkflowBoard
          boardKey="production"
          title="Production Workflow"
          subtitle="Preparation → review → filing · drag cards to advance the production pipeline"
          classicPath="/production/classic"
          boardEndpoint="/production/board"
          cardEndpointBase="/production/board/card"
          workspacePathFn={(pid) => `/production/${pid}`}
          transitionFn={({ card, toStage, method }) =>
            api.post("/production/board/transition", { entity_id: card.id, to_stage: toStage, method })}
        />
      </div>
    </div>
  );
}
